<template>
  <view-order-modal
    label="Penjualan"
    size="max-w-6xl"
    with-bonus
    with-shipping-fee
    edit-route-name="penjualan.edit"
    :order-detail-columns="[
      'code',
      'packed_qty',
      'unpacked_qty',
      'qty',
      'weight',
      'total_price',
      'pv',
      'bv',
      'total_weight',
    ]"
    :order-id="orderId"
    printable
    :visible="visible"
    :display-default-area-price="displayDefaultAreaPrice"
    @close="$emit('close')"
    @validated="$emit('refresh')"
    @deleted="$emit('refresh')"
    @reissued="$emit('refresh')"
  >
    <template
      #attributes="{ classes, order, destinationOffice, saveReferenceCode }"
    >
      <div class="w-full">
        <dt class="text-xs text-gray-700">No. Penjualan</dt>
        <dd class="mt-1 text-sm font-bold text-gray-900">
          <base-input
            size="sm"
            placeholder="Masukkan no order"
            :shadow="false"
            type="text"
            v-model="order.data.attributes.reference_code"
            @change="saveReferenceCode"
          />
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">No. Faktur</dt>
        <dd class="mt-1 text-sm text-gray-700">
          <OrderCodeLabel :order="order.data" />
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Dibuat Tanggal</dt>
        <dd :class="classes.dd">
          <order-date-label :order="order.data" />
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Kode Kantor</dt>
        <dd :class="classes.dd">
          {{ destinationOffice ? destinationOffice.attributes.code : '-' }}
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Dibuat Oleh</dt>
        <dd :class="classes.dd">
          {{
            order.data.attributes.created_by
              ? order.data.attributes.created_by.office.name
              : '-'
          }}
          /
          {{
            order.data.attributes.created_by
              ? order.data.attributes.created_by.user.name
              : '-'
          }}
        </dd>
      </div>
      <div v-if="order.data.attributes.is_valid_for_payment">
        <dt :class="classes.dt">Divalidasi Oleh</dt>
        <dd :class="classes.dd">
          {{ order.data.attributes.validated_by ?? '-' }}
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Wilayah Area</dt>
        <dd :class="classes.dd">
          <div class="flex items-center gap-2">
            <p>
              {{ order.data.attributes.area_name }}
              ({{ order.data.attributes.area_code }})
            </p>
            <order-area-status-badge
              v-if="
                order.data.attributes.area_status &&
                order.data.attributes.area_status !== 'valid'
              "
              :area-status="order.data.attributes.area_status"
            />
          </div>
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Diambil/Dikirim</dt>
        <dd :class="classes.dd">
          {{
            order.data.attributes.order_shipment === 'pickup'
              ? 'Diambil'
              : 'Dikirim'
          }}
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Nama</dt>
        <dd :class="classes.dd">
          {{ destinationOffice ? destinationOffice.attributes.name : '-' }}
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Alamat Kantor</dt>
        <dd :class="classes.dd">
          {{
            destinationOffice ? destinationOffice.attributes.full_address : '-'
          }}
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Diupdate Oleh</dt>
        <dd :class="classes.dd">
          {{ order.data.attributes.latest_update_by ?? '-' }}
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Diupdate Pada</dt>
        <dd :class="classes.dd">
          {{ order.data.attributes.updatedAt | formatDate }}
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Kode Gudang/Gudang Tujuan</dt>
        <dd :class="classes.dd">
          {{ order.data.attributes.destination_office_code }} /
          {{ order.data.attributes.destination_warehouse_code }}
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Nomor Telpon</dt>
        <dd :class="classes.dd">
          {{ destinationOffice ? destinationOffice.attributes.phone : '-' }}
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Metode Penjualan</dt>
        <dd :class="classes.dd">
          {{
            order.data.attributes.is_using_stock
              ? 'Dengan Barang'
              : 'Tanpa Barang'
          }}
        </dd>
      </div>
      <div v-if="order.data.attributes.order_shipment === 'delivery'">
        <dt :class="classes.dt">Dikirim ke Alamat</dt>
        <dd :class="classes.dd">
          {{ order.data.attributes.complete_shipment_address ?? '' }}
        </dd>
      </div>
      <div>
        <dt :class="classes.dt">Catatan</dt>
        <dd :class="classes.dd">
          {{ order.data.attributes.notes || '-' }}
        </dd>
      </div>
    </template>
  </view-order-modal>
</template>

<script>
import ViewOrderModal from '@/components/order/view-order-modal.vue';
import OrderDateLabel from './order-date-label.vue';
import OrderAreaStatusBadge from './order-area-status-badge.vue';
import OrderCodeLabel from './order-code-label.vue';

export default {
  components: {
    ViewOrderModal,
    OrderDateLabel,
    OrderAreaStatusBadge,
    OrderCodeLabel
  },
  props: {
    orderId: String,
    visible: Boolean,
    displayDefaultAreaPrice: Boolean
  },
  emits: ['close', 'refresh'],
};
</script>
